module.exports = __webpack_public_path__ + "static/media/SP_LOGO_VC.39286fcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/SP_LOGO_VC.png
// module id = 2022
// module chunks = 0